import { type FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { usePostMagazineOnelineMenuItems } from "scmp-app/components/post-magazine/use-oneline-menu-items";

import IconArrowDarkGray from "./icon-arrow-dark-gray.svg";
import {
  Container,
  StyledHeaderOnelineMenuContainer,
  StyledPostMagazineOnelineMenu,
} from "./styles";

type Props = HeaderFeatureCommonProps;

export const PostMagazineOnelineMenuContent: FunctionComponent<Props> = props => {
  const items = usePostMagazineOnelineMenuItems();

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledPostMagazineOnelineMenu reference={items} />
      <StyledHeaderOnelineMenuContainer
        icon={IconArrowDarkGray}
        isShowFullList={false}
        isShowPrefixHyphen={false}
      />
    </Container>
  );
};

PostMagazineOnelineMenuContent.displayName = "PostMagazineOnelineMenuContent";
